
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
  },
  model: {
    prop: 'modelValue',
    event: 'change',
  }
})
export default class Select extends Vue {
    @Prop({ default: [] }) options: [{ text: string; value: string | number }];
    @Prop({ type: String, default: '' }) name: string;
    @Prop({ type: String, default: '' }) form: string;
    @Prop({ default: '' }) modelValue: string | number;
    @Prop({ type: Boolean, default: false }) multiple: boolean;
    @Prop({ type: Boolean, default: false }) autofocus: boolean;
    @Prop({ type: Boolean, default: false }) autocomplete: boolean;
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select#attr-size
    @Prop({ type: String, default: 'normal' }) size: string;
    @Prop({ type: String, default: 'primary' }) variant: string;
    @Prop({ type: Boolean, default: false }) disabled: boolean;
    @Prop({ type: Boolean, default: false }) loading: boolean;

    get selected() {
      return this.modelValue || 0;
    }

    set selected(value) {
      this.$emit('change', value);
    }

    get disenabled() {
      return this.loading || this.disabled;
    }

    get classes() {
      return {
        [this.name]: true,
        [this.size]: true,
      }
    }

    get useOptions() {
      return [{ text: 'Please select an option', value: 0 }, ...this.options];
    }
}
